/******************************************************
 *                  Global exploitation Courses Ctrl
 ********************************************************/
"use strict";


import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

angular.module("exploitation")

	.controller("ExploitCoursesCtrl", ["$route", "$scope", "$log", "CONSTANTS", "Utils", "$uibModal", "timetables", "ExploitationService", "ExploitationVehicleJourneyService", "$routeParams", "$location", "$filter", "toastr", "ExploitTimetablesService", "SecurityService", "SharedProperties",
		function ($route, $scope, $log, CONSTANTS, Utils, $uibModal, timetables, ExploitationService, ExploitationVehicleJourneyService, $routeParams, $location, $filter, toastr, ExploitTimetablesService, SecurityService, SharedProperties) {

		/******************************************************
		 *                  SETUP
		 ********************************************************/
		$scope.data = {
			newCourse: {
				displayed: false,
				schedule: []
			},
			editMode: [],
			stopPointsList: [],
			currentNetwork: undefined,
			currentLine: undefined,
			currentRoute: undefined,
			networks: [],
			lines: [],
			routes: [],
			courses: [],
			matrix: {
				interval: 12,
				firstCourse: dayjs().hour(7).minute(30).second(0).millisecond(0).toDate(),
				lastCourse: dayjs().hour(9).minute(0).second(0).millisecond(0).toDate()
			},
			currentEditedCourse: undefined,
			globalEditMode: false,
			coursesSelected: {},
			selectedTimetables: [],
			coursesPagination: {
				currentPage: 1,
				pageSize: 10,
				paginated: true,
				totalResults: 1
			},
			toDelete: {},
			dateSelected: new Date()
		};

		$scope.isMarketing = SecurityService.hasRight('marketing');

		const BoardingAlightingPossibilityEnum = {
			BOARD_AND_ALIGHT: "BoardAndAlight",
			ALIGHT_ONLY: "AlightOnly",
			BOARD_ONLY: "BoardOnly",
			NEITHER_BOARD_OR_ALIGHT: "NeitherBoardOrAlight",
			BOARD_AND_ALIGHT_ON_REQUEST: "BoardAndAlightOnRequest",
			ALIGHT_ON_REQUEST: "AlightOnRequest",
			BOARD_ON_REQUEST: "BoardOnRequest",
			DROP_OFF_DRIVER_CALL: "DropOffDriverCall",
			DROP_OFF_STD_PICKUP_DRIVER_CALL: "DropOffStdPickUpOnDriverCall",
			DROP_OFF_STD_PICKUP_AGENCY_CALL: "DropOffStdPickUpOnAgencyCall",
			BOARD_ON_DRIVER_CALL: "BoardOnDriverCall",
			DROP_OFF_DRIVER_CALL_PICKUP_DRIVER_CALL: "DropOffDriverCallPickUpDriverCall",
			DROP_OFF_DRIVER_CALL_PICKUP_AGENCY_CALL: "DropOffDriverCallPickUpAgencyCall",
			DROP_OFF_DRIVER_CALL_PICKUP_STD: "DropOffDriverCallPickUpStd",
			DROP_OFF_AGENCY_CALL_PICKUP_STD: "DropOffAgencyCallPickUpStd",
			DROP_OFF_AGENCY_CALL_PICKUP_DRIVER_CALL: "DropOffAgencyCallPickUpDriverCall"
		};

		const BoardingAlightingPossibilityEnumAndLabels = [
			{
				"label": "Montée et descente autorisées",
				"value": BoardingAlightingPossibilityEnum.BOARD_AND_ALIGHT
			},
			{
				"label": "Descente autorisée uniquement",
				"value": BoardingAlightingPossibilityEnum.ALIGHT_ONLY
			},
			{
				"label": "Montée autorisée uniquement",
				"value": BoardingAlightingPossibilityEnum.BOARD_ONLY
			},
			{
				"label": "Montée et descente interdites",
				"value": BoardingAlightingPossibilityEnum.NEITHER_BOARD_OR_ALIGHT
			},
			{
				"label": "Montée et descente à la demande",
				"value": BoardingAlightingPossibilityEnum.BOARD_AND_ALIGHT_ON_REQUEST
			},
			{
				"label": "Descente à la demande uniquement",
				"value": BoardingAlightingPossibilityEnum.ALIGHT_ON_REQUEST
			},
			{
				"label": "Montée à la demande uniquement",
				"value": BoardingAlightingPossibilityEnum.BOARD_ON_REQUEST
			},
			{
				"label": "Descente sur appel chauffeur uniquement",
				"value": BoardingAlightingPossibilityEnum.DROP_OFF_DRIVER_CALL
			}
			,
			{
				"label": "Descente standard. Montée sur appel chauffeur",
				"value": BoardingAlightingPossibilityEnum.DROP_OFF_STD_PICKUP_DRIVER_CALL
			}
			,
			{
				"label": "Descente standard. Montée sur appel agence",
				"value": BoardingAlightingPossibilityEnum.DROP_OFF_STD_PICKUP_AGENCY_CALL
			}
			,
			{
				"label": "Montée sur appel chauffeur. Pas de descente",
				"value": BoardingAlightingPossibilityEnum.BOARD_ON_DRIVER_CALL
			}
			,
			{
				"label": "Montée et descente sur appel chauffeur",
				"value": BoardingAlightingPossibilityEnum.DROP_OFF_DRIVER_CALL_PICKUP_DRIVER_CALL
			}
			,
			{
				"label": "Descente sur appel chauffeur.Montée sur appel agence",
				"value": BoardingAlightingPossibilityEnum.DROP_OFF_DRIVER_CALL_PICKUP_AGENCY_CALL
			}
			,
			{
				"label": "Desccente sur appel agence. Montée standard",
				"value": BoardingAlightingPossibilityEnum.DROP_OFF_AGENCY_CALL_PICKUP_STD
			}
			,
			{
				"label": "Desccente sur appel agence. Montée sur appel chauffeur",
				"value": BoardingAlightingPossibilityEnum.DROP_OFF_AGENCY_CALL_PICKUP_DRIVER_CALL
			}
		];

		$scope.BoardingAlightingPossibilityEnumAndLabels = BoardingAlightingPossibilityEnumAndLabels;

		let generateCoursesModal, deleteCourseModal, linkToTimetableModal, courseInfoModal, tadModal,
			deleteTimetableToLineInfoModal, boardingAlightingEditModal, horairesMatrixBackup, courseBackup;

		/**
		 * Restful navigation.
		 */
		if ($routeParams.routeId) {
			$scope.data.currentRoute = $routeParams.routeId;
			getCourses();
		}


		/******************
		 * SCOPE FUNCTIONS
		 ******************/

		// Gestion Date Selector
		$scope.openDateSelector = function ($event) {
			$event.preventDefault();
			$event.stopPropagation();
			$scope.dataDateSelected.dateOpened = true;
		};

		$scope.dataDateSelected = {
			dateFormat: "dd/MM/yyyy",
			date: new Date(),
			maxDate: new Date(),
			format: "longDate",
			dateOptions: {
				startingDay: 1
			},
			counterTypesSelected: {},
			state: {
				editing: false,
				isOneGroupSelected: false,
				areSeveralGroupsSelected: false
			},
			selected: []
		};

		let previouslySelectedDate = SharedProperties.getAttribute("dateSelected");

		if (previouslySelectedDate != null && previouslySelectedDate !== undefined) {
			$scope.data.dateSelected = previouslySelectedDate;
		}


		$scope.openLinkToTimetableModal = function () {
			$scope.timetablesMode = "link";
			ExploitTimetablesService.getAllTimetables(1, "endOfPeriod", "desc").then((response) => {
				$scope.data.timetables = response.data;
			});
			linkToTimetableModal = $uibModal.open({
				templateUrl: "timetablesModal.html",
				size: "lg",
				scope: $scope
			});
		};

		$scope.getCourses = function () {
			SharedProperties.setAttribute("dateSelected", $scope.data.dateSelected);
			getCourses();
		};

		$scope.changeCoursePath = function (route) {
			initializeData(route);
			$location.url("/e-iti/courses/" + route);
		};

		$scope.addSelectedAllTimetables = function () {
			ExploitTimetablesService.getAllTimetables(undefined, "endOfPeriod", "desc").then((response) => {
				$scope.data.selectedTimetables = angular.copy(response.data.list);
			});
		};

		$scope.removeSelectedAllTimetables = function () {
			$scope.data.selectedTimetables = [];
		};

		$scope.openFilterByTimetableModal = function () {
			$scope.data.selectedTimetables = [];
			$scope.timetablesMode = "filter";
			ExploitTimetablesService.getAllTimetables(1, "endOfPeriod", "desc").then((response) => {
				$scope.data.timetables = response.data;
			});
			linkToTimetableModal = Utils.openModal($uibModal, "timetablesModal.html", $scope, "lg");
		};

		$scope.timetableSelected = function (timetable) {
			console.log(timetable);
		};

		$scope.linkCoursesToTimetable = function (course) {
			let courseIds;
			if ($scope.data.globalEditMode) {
				courseIds = getSelectedCoursesArray();
			} else {
				courseIds = [course.id];
			}

			ExploitationVehicleJourneyService.linkCoursesToTimetables(courseIds, $scope.data.selectedTimetables)
				.then(() => {
					getCourses();
					toastr.success("Les courses ont été associées aux calendriers");
					linkToTimetableModal.close();
				})
				.catch((error) => {
					const data = error.data;
					let errorMessage = "Problème lors de l'association des courses aux calendriers. ";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});

		};

		$scope.removeTimetableFromSelection = function (timetable) {
			$scope.data.selectedTimetables.forEach(function (elem, index) {
				if (elem.id === timetable.id) {
					$scope.data.selectedTimetables.splice(index, 1);
				}
			});
		};

		/**
		 * Est-ce qu'un calendrier fait partie des calendriers sélectionnés.
		 * @param timetable
		 * @returns {boolean}
		 */
		$scope.timetableSelected = function (timetable) {
			return $scope.data.selectedTimetables.filter(function (tt) {
				return timetable.id === tt.id;
			}).length > 0;
		};


		/**
		 * Open the model and stores a reference so it can be closed programatically.
		 */
		$scope.openEditCoursesModal = function () {
			generateCoursesModal = Utils.openModal($uibModal, "editCoursesModal.html", $scope);
		};

		/**
		 * Enter edit mode to add a new course ('plus sign' column in the table).
		 */
		$scope.editNewCourse = function () {
			$scope.data.newCourse.displayed = true;
			let i = 0;
			$scope.data.newCourse.horaires = $scope.data.stopPointsList.stop_points.map(stopPoint => {
				i++;
				let date = dayjs("00:00", "HH:mm").toDate();
				date.setMinutes(date.getMinutes() + i)
				return {
					stopId: stopPoint.stop_point_id,
					commercial_name: stopPoint.commercial_name,
					heure_arrivee: date,
					heure_depart: date
				};
			});
		};

		/**
		 * Quit edit mode for a new course.
		 * Reset inputed data/
		 */
		$scope.cancelNewCourseEdition = function () {
			$scope.data.newCourse.displayed = false;
			$scope.data.newCourse.schedule = [];
		};

		/**
		 * Used to compute on the fly time delta between two times.
		 * Used in the popup, to show time deltas in the time matrix table.
		 * @param time1 current course time
		 * @param time2 previous course time
		 * @returns {*} time difference in 'HH:mm' format or '--:--' if NA.
		 */
		$scope.computeAndFormatTimeDelta = function (time1, time2) {
			if (time1 && time2) {
				return dayjs().utc(dayjs(time1).diff(dayjs(time2))).format("HH:mm");
			} else {
				return "--:--";
			}
		};


		/**
		 * Enter edit mode in the matrix table.
		 * Backup the times so it can be restored if cancel button is pushed.
		 */
		$scope.enterMatrixEditMode = function () {
			$scope.data.matrixEditMode = true;
			horairesMatrixBackup = angular.copy($scope.data.matrix.sampleCourseTimes.horaires);
		};

		/**
		 * Restore data and qui edit mode in the matrix table.
		 */
		$scope.cancelMatrixEdition = function () {
			$scope.data.matrixEditMode = false;
			$scope.data.matrix.sampleCourseTimes.horaires = horairesMatrixBackup;
		};

		/**
		 * Quit edit mode and fill the $scope.data.matrix.coursesInterval table, providing time deltas between
		 * each stop point for this course
		 */
		$scope.validateMatrix = function () {
			$scope.data.matrixEditMode = false;
			$scope.data.matrix.coursesIntervals = [0];
			for (var i = 1; i < $scope.data.matrix.sampleCourseTimes.horaires.length; i++) {
				var horaire = $scope.data.matrix.sampleCourseTimes.horaires[i];
				$scope.data.matrix.coursesIntervals[i] = computeTimeDelta(horaire.heure_depart, $scope.data.matrix.sampleCourseTimes.horaires[i - 1].heure_depart, {unit: "minutes"});
			}
		};

		/**
		 * Generates and posts new courses.
		 */
		$scope.generateCourses = function () {
			var currentRoute;

			for (var routeIndex in $scope.data.routes) {
				if ($scope.data.routes[routeIndex].id === $scope.data.currentRoute) {
					currentRoute = $scope.data.routes[routeIndex];
				}
			}

			$scope.validateMatrix();

			// will store the ocurses to create
			var coursesJourney = [];

			// compute first stop time
			var nextCourseFirstStopTimeMoment = dayjs($scope.data.matrix.firstCourse);

			// while last created course is before last course due.
			while (dayjs($scope.data.matrix.lastCourse).diff(nextCourseFirstStopTimeMoment) >= 0) {

				var newCourse = [{}];

				// Put first stop time : firstCourse for the former iteration, same value increased by matrix.interval for newt iterations
				// Value is computed at yhe end of the loop (or before the loop for the former iteration).
				newCourse[0].departure_time = nextCourseFirstStopTimeMoment.format("HH:mm");
				newCourse[0].stop_area = $scope.data.matrix.sampleCourseTimes.horaires[0].stopId;

				// for each stop point, get the previous stop point time and add the time difference between the two stop points
				// stored in the $scope.data.matrix.coursesIntervals array
				for (var i = 1; i < $scope.data.matrix.sampleCourseTimes.horaires.length; i++) {
					var time = dayjs(newCourse[i - 1].departure_time, "HH:mm");
					time.add($scope.data.matrix.coursesIntervals[i], "minutes");
					newCourse.push(
						{
							departure_time: time.format("HH:mm"),
							arrival_time: time.format("HH:mm"),
							stop_area: $scope.data.matrix.sampleCourseTimes.horaires[i].stopId
						}
					);
				}

				// Store the created course to be posted later on.
				coursesJourney.push(newCourse);
				// finally compute new course first top time to eventually finish the loop.
				nextCourseFirstStopTimeMoment.add($scope.data.matrix.interval, "minutes");
			}

			// POST courses, display notification and close popup. Full refresh of data.
			ExploitationService.addCourses($scope.data.currentRoute, currentRoute.name, currentRoute.name, coursesJourney)
				.then(() => {
					generateCoursesModal.close();
					toastr.success("Les courses ont été ajoutées.", "");
					initializeData($scope.data.currentRoute);
				});
		};


		$scope.openCourseInfoModal = function (course) {
			$scope.data.selectedCourse = course;

			courseInfoModal = $uibModal.open({
				templateUrl: "courseInfoModal.html",
				scope: $scope,
				size: "lg"
			});
		};


		$scope.openTadModal = function (course) {
			$scope.data.selectedCourse = course;
			$scope.data.tad = isFullCourseTAD(course);

			tadModal = $uibModal.open({
				templateUrl: "tadModal.html",
				scope: $scope,
				size: "lg"
			});
		};


		$scope.backOpenCourseInfoModal = function (course) {
			deleteTimetableToLineInfoModal.close();
			$scope.openCourseInfoModal(course);
		};


		const dialogController = function ($scope) {
			$scope.unlinkCalendarFromCourse = function (course, timetable) {
				ExploitationVehicleJourneyService.unlinkCourseFromTimetable(course, timetable)
					.then(() => {
						// Supprimer le calendrier de manière définitive dans les $scope.data.courses
						var indexCourse = $scope.data.courses.indexOf(course);
						var indexTimetables = $scope.data.courses[indexCourse].timetableIds.indexOf(timetable.id);
						$scope.data.courses[indexCourse].timetableIds.splice(indexTimetables, 1);
						// Supprimer de l'affichage du modal
						toastr.success("Le calendrier n'est plus lié à la course.");
						deleteTimetableToLineInfoModal.close();
						getCourses();
						$scope.openCourseInfoModal(course);
					})
					.catch((error) => {
						const data = error.data;
						let errorMessage = "Problème lors de l'opération. ";
						if (data !== undefined && data.message) {
							errorMessage += data.message;
						}
						toastr.error(errorMessage, "Erreur");
					});

			};
		};
		/**
		 * Supprimer un calendrier d'une course
		 * @param course
		 */
		$scope.deleteTimetableToLineModal = function (course, timetable) {

			$scope.data.toDelete.course = course;
			$scope.data.toDelete.timetable = timetable;

			courseInfoModal.close();

			deleteTimetableToLineInfoModal = $uibModal.open({
				templateUrl: "deleteTimetableToLineInfoModal.html",
				scope: $scope,
				controller: ['$scope', dialogController],
				size: "md"
			});
		};


		/**
		 * Enter edit mode for a particular course.
		 * Backup course data first, so it can be restored.
		 * @param course
		 */
		$scope.enterCourseEditMode = function (course) {
			$scope.data.currentEditedCourse = course.id;
			courseBackup = angular.copy(course);
		};

		/**
		 * Restore data and quit edit mode.
		 * @param course
		 */
		$scope.cancelCourseEdition = function (course) {
			//find current course in scope data and put data back as it was before editing.
			for (var i = 0; i < $scope.data.courses.length; i++) {
				var currentLoopCourse = $scope.data.courses[i];
				if (currentLoopCourse.id === course.id) {
					$scope.data.courses[i] = courseBackup;
					break;
				}
			}
			$scope.data.currentEditedCourse = undefined;
		};

		/**
		 * Validate course edition(green check button). POST course data and display notification.
		 * @param course
		 */
		$scope.validateCourseEdition = function (course) {
			if (validateScheduleVehicleJourney(course)) {
				ExploitationService.updateCourse($scope.data.currentRoute, course)
					.then(
						() => {
							$scope.data.currentEditedCourse = undefined;
							toastr.success("Course " + course.id + " modifiée avec succès", "");
							if ($scope.boardingAlightingEditModal) {
								$scope.editBoardingAlightingStopPoint();
							}
							initializeData($scope.data.currentRoute);
						},
						(error) => {
							console.error(error);
							toastr.error("", "Problème lors de la modification de la course.");
						}
					);
			}
		};

		/**
		 * Valide la cohérence des horaires de la course
		 * @param course
		 * @returns {boolean}
		 */
		function validateScheduleVehicleJourney(course) {
			$log.info(course);
			let previousHeureArrivee, previousHeureDepart;
			for (let scheduleId in course.horaires) {
				let schedule = course.horaires[scheduleId];
				if (schedule.heure_arrivee > schedule.heure_depart) {
					toastr.error("Heure d'arrivée > heure départ sur l'arrêt: " + schedule.commercial_name, "Impossible de modifier la course");
					return false;
				}


				if (previousHeureArrivee != null
					&& previousHeureDepart != null
					&& (schedule.heure_arrivee < previousHeureDepart || schedule.heure_arrivee < previousHeureArrivee)) {
					toastr.error("Heure d'arrivée < heure départ précédent pour l'arrêt: " + schedule.commercial_name, "Impossible de modifier la course");
						return false;
				}

				previousHeureArrivee = schedule.heure_arrivee;
				previousHeureDepart = schedule.heure_depart;

			}
			return true;
		}

		/**
		 * Open route deletion modal confirmation.
		 */
		$scope.openDeleteCourseModal = function () {
			deleteCourseModal = Utils.openModal($uibModal, "deleteCourseModal.html", $scope);
		};

		$scope.deleteCourse = function () {
			ExploitationService.deleteCourse($scope.data.currentEditedCourse)
				.then(() => {
					deleteCourseModal.close();
					toastr.success("Course " + $scope.data.currentEditedCourse + " supprimée avec succès", "");
					initializeData($scope.data.currentRoute);
				})
				.catch(() => {
					toastr.error("", "Problème lors de la suppression de la course.");
				});

		};

		$scope.deleteCourses = function () {

			ExploitationService.deleteCourses(getSelectedCoursesArray())
				.then(() => {

					deleteCourseModal.close();
					$scope.data.globalEditMode = false;
					toastr.success("Courses supprimée avec succès", "");
					initializeData($scope.data.currentRoute);
				})
				.catch(() => {
					toastr.error("", "Problème lors de la suppression de la course.");
				});


		};

		$scope.cancelGlobalEditMode = function () {
			$scope.data.globalEditMode = false;
			$scope.data.coursesSelected = {};
		};

		var lastColumnIndex;
		$scope.checkForShiftKey = function (event, index, checked) {
			if (event.shiftKey) {
				// select all columns between this one and currentColumnIndex
				if (index > lastColumnIndex) {
					for (var i = lastColumnIndex + 1; i <= index; i++) {
						$scope.data.coursesSelected[$scope.data.courses.list[i].id] = true;
					}
				} else {
					for (var i = lastColumnIndex - 1; i >= index; i--) {
						$scope.data.coursesSelected[$scope.data.courses.list[i].id] = true;
					}
				}

			} else {
				// no shift key => let's store a reference to the index of this column
				lastColumnIndex = index;
			}

		};


		$scope.addCourse = function (newCourse) {
			var horaires = [];
			for (var i = 0; i < newCourse.horaires.length; i++) {
				var time = newCourse.horaires[i].heure_arrivee;
				horaires.push({
					stop_area: $scope.data.stopPointsList.stop_points[i].stop_point_id,
					departure_time: dayjs(time).format("HH:mm"),
					arrival_time: dayjs(time).format("HH:mm")
				});
			}
			if (validateScheduleVehicleJourney(newCourse)){
				ExploitationService.addCourses($scope.data.currentRoute, newCourse.public_id, newCourse.public_name, [horaires])
					.then(() => {
						$scope.data.newCourse.displayed = false;
						toastr.success("Course(s) ajoutées(s) avec succès", "");
						initializeData($scope.data.currentRoute);
						$scope.data.newCourse = {
							schedule: [] // fixes #487
						};
					})
					.catch((error) => {
						toastr.error(Utils.makeErrorMessage(error.data, "Problème lors de l'ajout de la course."));
					});
			}



		};


		$scope.areNewCoursesSchedulesValid = function () {
			for (var i = 0; i < $scope.data.newCourse.schedule.length; i++) {
				if (!$scope.data.newCourse.schedule[i]) {
					return false;
				}
			}
			return true;
		};


		$scope.refreshTimetables = function () {
			return ExploitTimetablesService.refreshTimetables($scope);
		};

		$scope.getTimetableCardColor = ExploitTimetablesService.getTimetableCardColor;


		/******************
		 * UTILS
		 ******************/
		/**
		 * Compute time delta between two times at string format.
		 * @param time1 current time
		 * @param time2 previous time
		 * @param options an oject to this format :
		 * {
		 *  format: 'HH:mm', //format of the given time strings
		 *  unit: 'milliseconds' // wanted result unit. See http://momentjs.com/docs/#/displaying/format/ for accepted formats.
		 * }
		 *
		 * @returns {*}
		 */
		var computeTimeDelta = function (time1, time2, options) {
			if (options) {
				if (!options.format) options.format = "HH:mm";
				if (!options.unit) options.unit = "milliseconds";
			} else {
				options =
					{
						format: "HH:mm",
						unit: "milliseconds"
					};
			}
			var moment1 = dayjs(time1);
			var moment2 = dayjs(time2);
			return moment1.diff(moment2, options.unit);
		};


		/**
		 * Initialize all data on screen according to a route id.
		 * @param routeId
		 */
		function initializeData(routeId) {
			// STOP POINTS & CURRENT NETWORK & CURRENT LINE & CURRENT ROUTE
			ExploitationService.getRoute(routeId).then((response) => {
				const stopPointsData = response.data;
				$scope.data.stopPointsList = stopPointsData;

				$scope.data.currentNetwork = stopPointsData.network;
				$scope.data.currentLine = stopPointsData.line;
				$scope.data.currentRoute = stopPointsData.id;

				// LINES
				ExploitationService.getLines($scope.data.currentNetwork).then((response) => {

					$scope.data.lines = response.data;

					// ROUTES
					ExploitationService.getRoutes($scope.data.currentLine).then((response) => {
						$scope.data.routes = response.data;
						// COURSES

						getCourses();
					});
				});
			});

		}


		function getSelectedCoursesArray() {
			var keys = Object.keys($scope.data.coursesSelected);
			var coursesToDelete = [];
			for (var i = 0; i < keys.length; i++) {
				var key = keys[i];
				if ($scope.data.coursesSelected[key]) {
					coursesToDelete.push(key);
				}
			}
			return coursesToDelete;
		}


		function getCourses() {
			ExploitationService.getRoute($scope.data.currentRoute, false).then((response) => {
				const journeyPattern = response.data;
				if ($scope.data.currentNetwork === undefined && $scope.data.currentLine === undefined) {
					$scope.data.currentNetwork = journeyPattern.network;
					$scope.data.currentLine = journeyPattern.line;
				}

				$scope.data.stopPointsList = journeyPattern;
				$scope.data.currentRoute = journeyPattern.id;

				var params = {
					"route": $scope.data.currentRoute,
					"page": $scope.data.coursesPagination.currentPage,
					"pageSize": $scope.data.coursesPagination.pageSize,
					"paginated": $scope.data.coursesPagination.paginated
				};

				if ($scope.data.dateSelected !== null && $scope.data.dateSelected !== undefined) {
					params.date = $scope.data.dateSelected.getDate() + "-" + ($scope.data.dateSelected.getMonth() + 1) + "-" + $scope.data.dateSelected.getFullYear();
				}

				ExploitationService.getVehicleJourneysForJourneyPattern(params)
					.then((response) => {
						const data = response.data;
						let courses;
						if ($scope.data.coursesPagination.paginated){
							courses = data.list;
							$scope.data.coursesPagination.totalResults = data.totalResults;
						} else {
							courses = data;
						}


						for (let i = 0; i < courses.length; i++) {
							let course = courses[i];
							for (let j = 0; j < course.horaires.length; j++) {
								let horaire_depart = course.horaires[j].heure_depart;
								course.horaires[j].heure_depart = dayjs(horaire_depart, "HH:mm").toDate();

								let horaire_arrivee = course.horaires[j].heure_arrivee;
								course.horaires[j].heure_arrivee = dayjs(horaire_arrivee, "HH:mm").toDate();
							}
							ExploitTimetablesService.getTimetables(course.timetableIds).then((response) => {
								course.day = response.data;
							});
						}

						$scope.data.courses = courses;

						// Si une course était déjà sélectionné on la met a jour
						if ($scope.data.selectedCourse != null) {
							$scope.data.selectedCourse = $scope.data.courses.find(c => c.id === $scope.data.selectedCourse.id);
						}

						if (courses.list && courses.list.length) {
							// If there's already courses, take the first one as the time matrix.
							$scope.data.matrix.sampleCourseTimes = angular.copy($scope.data.courses.list[0]);
						} else {
							// if no courses, fill an array with 00:00 times and copy stop points from stop_points data table.
							$scope.data.matrix.sampleCourseTimes = {horaires: []};
							for (var i = 0; i < $scope.data.stopPointsList.stop_points.length; i++) {
								var stopPointData = $scope.data.stopPointsList.stop_points[i];
								$scope.data.matrix.sampleCourseTimes.horaires.push({
									stopId: stopPointData.stop_point_id,
									heure_depart: dayjs().hour(0).minute(0).second(0).toDate,
									heure_arrivee: dayjs().hour(0).minute(0).second(0).toDate
								});
							}
						}
						$scope.data.isCoursesTAD = isCoursesTAD();
					});
			});

		}

		/**
		 * Recherche parmi toutes les courses si l'une d'elles est TAD
		 */
		function isCoursesTAD() {
			let isTAD = false;

			for (let i = 0; i < $scope.data.courses.length; i++) {
				for (let j = 0; j < $scope.data.courses[i].horaires.length; j++) {
					if ($scope.data.courses[i].horaires[j].is_tad) {
						isTAD = true;
						break;
					}
				}

				if (isTAD) {
					break;
				}
			}

			return isTAD;
		}


		// PAGINATION
		$scope.refreshCourses = function () {
			getCourses();
		};

		$scope.getCssStyleBoardingAlighting = (value) => {
			const gradient = $scope.getColorAccordingToEnumPossibilities(value);
			return {
				'background': "linear-gradient(-135deg,"+gradient+")"
			}
		}

		$scope.getCssStyleBoardingAlightingPopup = (value) => {
			const gradient = $scope.getColorAccordingToEnumPossibilities(value);
			return {
				'width': '14px',
				'height': '14px',
				'padding' : '6px 8px',
				'background': "linear-gradient(-135deg,"+gradient+")"
			}
		}

		$scope.getColorAccordingToEnumPossibilities = (value) => {
			switch (value) {
				default:
				case BoardingAlightingPossibilityEnum.BOARD_AND_ALIGHT:
					return "#5cb85c 50%, #5cb85c 50%";
				case BoardingAlightingPossibilityEnum.BOARD_ONLY:
					return "#5cb85c 50%, #d9534f 50%";
				case BoardingAlightingPossibilityEnum.ALIGHT_ONLY:
					return "#d9534f 50%, #5cb85c 50%";
				case BoardingAlightingPossibilityEnum.NEITHER_BOARD_OR_ALIGHT:
					return "#d9534f 50%, #d9534f 50%";
				case BoardingAlightingPossibilityEnum.BOARD_ON_REQUEST:
					return "#f0ad4e 50%, #d9534f 50%";
				case BoardingAlightingPossibilityEnum.ALIGHT_ON_REQUEST:
					return "#d9534f 50%, #f0ad4e 50%";
				case BoardingAlightingPossibilityEnum.BOARD_AND_ALIGHT_ON_REQUEST:
					return "#f0ad4e 50%, #f0ad4e 50%";
				case BoardingAlightingPossibilityEnum.DROP_OFF_DRIVER_CALL:
					return "#d9534f 50%, #f0ad4e 50%";
				case BoardingAlightingPossibilityEnum.DROP_OFF_STD_PICKUP_DRIVER_CALL:
					return "#d9534f 50%, #5cb85c 50%";
				case BoardingAlightingPossibilityEnum.DROP_OFF_STD_PICKUP_AGENCY_CALL:
					return "#d9534f 50%, #5cb85c 50%";
				case BoardingAlightingPossibilityEnum.BOARD_ON_DRIVER_CALL:
					return "#f0ad4e 50%, #d9534f 50%";
				case BoardingAlightingPossibilityEnum.DROP_OFF_DRIVER_CALL_PICKUP_STD:
					return "#5cb85c 50%, #f0ad4e 50%";
				case BoardingAlightingPossibilityEnum.DROP_OFF_DRIVER_CALL_PICKUP_DRIVER_CALL:
					return "#f0ad4e 50%, #f0ad4e 50%";
				case BoardingAlightingPossibilityEnum.DROP_OFF_DRIVER_CALL_PICKUP_AGENCY_CALL:
					return "#f0ad4e 50%, #f0ad4e 50%";
				case BoardingAlightingPossibilityEnum.DROP_OFF_AGENCY_CALL_PICKUP_STD:
					return "#5cb85c 50%, #f0ad4e 50%";
				case BoardingAlightingPossibilityEnum.DROP_OFF_AGENCY_CALL_PICKUP_DRIVER_CALL:
					return "#5cb85c 50%, #f0ad4e 50%";
			}
		};

		/**
		 * Ouvre la modal d'édition des autorisations de montée/descente d'un PA
		 * @param $event
		 * @param stopPoint
		 */
		$scope.openBoardingAlightingEditPopup = ($event, stopPoint) => {
			$event.stopPropagation();

			if (!SecurityService.hasRight('canEditBoardingAlighting')) {
				return;
			}

			$scope.boardingAlightingEditModal = {
				originalStopPoint: stopPoint,
				stopPoint: angular.copy(stopPoint),
				selectValues: BoardingAlightingPossibilityEnumAndLabels
			};
			boardingAlightingEditModal = Utils.openModal($uibModal, "boardingAlightingEdit.html", $scope);
		};

		/**
		 * Valide l'edition des autorisations de montée/descente d'un stop_point
		 */
		$scope.editBoardingAlightingStopPoint = () => {
			const stopPoint = $scope.boardingAlightingEditModal.stopPoint;
			ExploitationService.updateVJASBoardingAndAlighting(stopPoint)
				.then(
					() => {
						toastr.success("Autorisations de montée/descente modifiées");
						boardingAlightingEditModal.close();
						$scope.boardingAlightingEditModal.originalStopPoint.boardingAlightingPossibility = $scope.boardingAlightingEditModal.stopPoint.boardingAlightingPossibility;
						updateStopPointTAD();
					},
					(error) => {
						Utils.makeErrorMessage(error.data, "Erreur lors de la modification des autorisations de montée/descente");
					}
				);
		};


		/**
		 * Update edited stop point to set is_TAD
		 */
		function updateStopPointTAD() {
			let currentEditedStopPoint = $scope.boardingAlightingEditModal.stopPoint;
			for (let i = 0; i < $scope.data.courses.length; i++) {
				const currentLoopCourse = $scope.data.courses[i];
				if (currentLoopCourse.id === currentEditedStopPoint.vehicleJourneyId) {
					updateStopPointTADInCourse(currentLoopCourse);
				}
			}
		}

		/**
		 * Update edited stop point to set is_TAD in the given course
		 */
		function updateStopPointTADInCourse(course) {
			let isStopPointTAD;
			isStopPointTAD = $scope.boardingAlightingEditModal.stopPoint.boardingAlightingPossibility === "BoardAndAlightOnRequest";

			for (let i = 0; i < course.horaires.length; i++) {
				const currentStopPoint = course.horaires[i];
				if (currentStopPoint.id === $scope.boardingAlightingEditModal.stopPoint.id) {
					currentStopPoint.is_tad = isStopPointTAD;
				}
			}
		}

		$scope.editJourneyTad = () => {
			tadModal.dismiss();
			$scope.editBoardingAlightingVJAS($scope.data.selectedCourse);
		}



		$scope.editBoardingAlightingVJAS = (course) => {

			let boardingAlightingPossibility;

			if (isFullCourseTAD(course)) {
				boardingAlightingPossibility = BoardingAlightingPossibilityEnum.BOARD_AND_ALIGHT;
			} else {
				boardingAlightingPossibility = BoardingAlightingPossibilityEnum.BOARD_AND_ALIGHT_ON_REQUEST;
			}

			ExploitationService.updateVJBoardingAndAlighting(course.id, boardingAlightingPossibility)
				.then(() => {
					toastr.success("Autorisations de montée/descente modifiées");
					getCourses();
				})
				.catch((error) => {
					Utils.makeErrorMessage(error.data, "La modification n'a pas pu être effectuée");
				});
		};

		/**
		 * Renvoie la bonne classe CSS (couleur du bouton) selon si la ligne est TAD
		 */
		$scope.getCssClassFromCourse = (course) => {

			if (isFullCourseTAD(course)) {
				return 'allowed';
			}

			if (isFullCourseStandard(course)) {
				return 'notallowed';
			}

			return 'partialallowed';
		}


		/**
		 * Checks if all stops of the course has standard conditions (standard = no TAD)
		 *
		 * @return
		 * 		true : all stops are standard
		 * 		false : at least one stop is TAD
		 */
		function isFullCourseStandard(course) {
			for (let i = 0; i < course.horaires.length; i++) {
				if (course.horaires[i].is_tad) {
					return false;
				}
			}
			return true;

		}

		/**
		 * Checks if all stops of the course is TAD
		 *
		 * @return
		 * 		true : all stops are TAD
		 * 		false : at least one stop is standard
		 */
		function isFullCourseTAD(course) {
			for (let i = 0; i < course.horaires.length; i++) {
				if (!course.horaires[i].is_tad) {
					return false;
				}
			}
			return true;

		}

		/**
		 * Recherche si la course est TAD
		 */
		$scope.isCourseTAD = (course) => {
			let isTAD = false;
			for (let i = 0; i < course.horaires.length; i++) {
				if (course.horaires[i].is_tad) {
					isTAD = true;
					break;
				}
			}
			return isTAD;
		}



		/**
		 * Change l'horaire de depart en fonction de l'horraire d'arrivée saisie dans la modification simple
		 */
		$scope.changeHoraireDepart = (vjas) => {
			if ($scope.data.advancedEdition === false) {
				vjas.heure_depart = vjas.heure_arrivee;
			}
		};


		$scope.$on("$locationChangeStart", function (event) {

			let newURL = $location.path();
			if (!newURL.includes("/e-iti/courses/")) {
				SharedProperties.setAttribute("dateSelected", null);
			}

		});
	}])
;
